import { jsx as _jsx } from "react/jsx-runtime";
export const ShortcutInfo = (param)=>{
    let { children, ...props } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "pointer-events-none flex min-h-[20px] w-fit min-w-[20px] items-center justify-center rounded-4 bg-grey-2 px-1 text-12 uppercase text-grey-11",
        ...props,
        children: children
    });
};
